import react from "../../assets/icons/react.svg"

const languages=[
    {
        icon:react,
        name:"HTML",
        level:"90"
    },
    {
        icon:react,
        name:"React Js",
        level:"90"
    },
    {
        icon:react,
        name:"Formik",
        level:"80"
    },
    {
        icon:react,
        name:"Redux",
        level:"80"
    },
   
    {
        icon:react,
        name:"Axios",
        level:"80"
    },
    {
        icon:react,
        name:"Hook",
        level:"75"
    },
   

]

const styling=[
    {
        icon:react,
        name:"CSS",
        level:"90"
    },
    {
        icon:react,
        name:"Bootstrap",
        level:"85"
    },
    {
        icon:react,
        name:"Material-Ui",
        level:"60"
    },
    {
        icon:react,
        name:"Git",
        level:"70"
    },
    {
        icon:react,
        name:"NPM",
        level:"70"
    },
]

export {styling,languages}